import React, { useEffect, useState } from "react";
import "../css/home.css";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import { Typography, Accordion, AccordionSummary } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { Helmet } from 'react-helmet';
import downloadGoogleImg from "../images/download-google-play.png";
import downloadAppleImg from "../images/download-app-store.png";
import phone1 from "../images/phone1.png";
import phone2 from "../images/phone2.png";
import downloadApp from "../images/download-app.png";


export default function PricingPage(props) {
  const [pricingData, setPricingData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState([]);

  const useStyles = makeStyles({
    table: {
      minWidth: window.innerWidth > 768 ? 400 : 300,
    },
  });

  const classes = useStyles();

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#3f3c8c",
      color: theme.palette.common.white,
      padding: 10,
      fontSize: window.innerWidth > 768 ? 16 : 12,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableCell2 = withStyles((theme) => ({
    body: {
      fontSize: window.innerWidth > 768 ? 14 : 10,
      padding: 10,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const columns = [
    {
      key: "pressOnly",
      label: "Press Only",
    },
    {
      key: "washAndPress",
      label: "Wash & Press",
    },
    {
      key: "dryCleaning",
      label: "Dry Cleaning",
    },
  ];

  const bags = [
    [
      { name: "Wash & Fold", calories: "55 AED" },
      { name: "Linen Bag", calories: "75 AED" },
      { name: "Press Only", calories: "85 AED" },
      { name: "Wash & Press", calories: "129 AED" },
    ],
  ];

  const getPricing = async () => {
    try {
      const pricingRes = await fetch(
        "https://api.washon.ae/user/services/map/pricing"
      );
      const pricingData = await pricingRes.json();

      if (pricingData) {
        setPricingData(pricingData);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const renderTable = (item) => {
    if (currentIndex.includes(item.category)) {
      return (
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <StyledTableCell>Item</StyledTableCell>
              {columns.map((col) => (
                <StyledTableCell align="center">{col.label}</StyledTableCell>
              ))}
            </TableHead>
            <TableBody>
              {item.items.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell2 component="th" scope="row">
                    {row.name}
                  </StyledTableCell2>

                  {Object.values(row.serviceCharges).map((charge) => (
                    <StyledTableCell2 align="center">{charge}</StyledTableCell2>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return null;
    }
  };

  useEffect(() => {
    getPricing();
  }, [currentIndex]);

  return (
    <div>
    <Helmet>
    <script type="application/ld+json">{`{ "@context": "https://schema.org", "@type": "DryCleaningOrLaundry", "name": "WashOn Laundry: Laundry Prices in Dubai", "description": "Transparent pricing: WashOn Laundry's price schema offers competitive rates, with the added convenience of free pickup and delivery, ensuring a hassle-free experience.", "image": "https://washon-image.s3.ap-south-1.amazonaws.com/site-image/washon-white-bg.png", "@id": "Washon Laundry Pricing", "url": "https://www.washon.ae", "telephone": "+971-506856502", "priceRange" : "AED 35 - AED 130", "address": { "@type": "PostalAddress", "streetAddress": "Downtown Dubai", "addressLocality": "Dubai", "postalCode": "0000", "addressCountry": "AE" }, "geo": { "@type": "GeoCoordinates", "latitude": 25.1949849, "longitude": 55.2784141 }, "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday" ], "opens": "08:00", "closes": "21:00" }, "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.83", "ratingCount": "879" }, "department": [{ "@type": "DryCleaningOrLaundry", "name": "WashOn Shoe Cleaning: Premium Shoe cleaning in Dubai. Shoe cleaning service near you", "description": "WashOn Laundry gives you high quality shoe cleaning service near you in Dubai. From sneakers to leather boots, we bring new life to your shoes with meticulous care and attention to detail.", "image": "https://washon-image.s3.ap-south-1.amazonaws.com/site-image/shoe-cleaning-washon.png", "telephone": "+971-506856502", "address": { "@type": "PostalAddress", "streetAddress": "Downtown Dubai", "addressLocality": "Dubai", "postalCode": "0000", "addressCountry": "AE" }, "geo": { "@type": "GeoCoordinates", "latitude": 25.1949849, "longitude": 55.2784141 }, "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday" ], "opens": "08:00", "closes": "21:00" } },{ "@type": "DryCleaningOrLaundry", "name": "WashOn Carpet Cleaning: Premium Carpet cleaning in Dubai. Carpet cleaning service near you", "description": "WashOn Laundry gives you high quality carpet cleaning service near you in Dubai.Restore your carpets to their former glory with our professional cleaning service.", "image": "https://washon-image.s3.ap-south-1.amazonaws.com/site-image/carpet-cleaning-washon.png", "telephone": "+971-506856502", "address": { "@type": "PostalAddress", "streetAddress": "Downtown Dubai", "addressLocality": "Dubai", "postalCode": "0000", "addressCountry": "AE" }, "geo": { "@type": "GeoCoordinates", "latitude": 25.1949849, "longitude": 55.2784141 }, "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday" ], "opens": "08:00", "closes": "21:00" } }] }`}</script>
    <title>WashOn Laundry, Curtain, Carpet and Shoe Cleaning: Prices </title>    
    <meta property="title" content="WashOn Laundry, Curtain, Carpet and Shoe Cleaning: Pricing" />
    <meta name="description" content="Explore WashOn Laundry Pricing: Affordable rates for premium laundry, shoe carpet and curtain cleaning services. Free Pickup and Delivery." />
    <meta name="keywords" content="Best laundry service in dubai, Laundry, Laundry in marina, Laundry service near me, Dry Cleaning In Dubai, Shoe cleaning in Dubai, Best laundry in dubai, Laundry Services, Carpet cleaner, laundry near me, laundry in Al furjan"/>
    <meta property="og:locale" content="en_US" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="WashOn Laundry, Curtain, Carpet and Shoe Cleaning: Pricing" />
    <meta property="og:description" content="Explore WashOn Laundry Pricing: Affordable rates for premium laundry, shoe carpet and curtain cleaning services. Discover our pricing options tailored to fit your needs." />
    <meta property="og:url" content="https://www.washon.ae/pricing" />
    <link rel="canonical" href="https://www.washon.ae/pricing" />
    <meta property="og:site_name" content="WashOn Laundry Service: Pricing" />
    <meta property="og:image" content="https://washon-image.s3.ap-south-1.amazonaws.com/site-image/washon-white-bg.png" />
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:title" content="WashOn Laundry, Curtain, Carpet and Shoe Cleaning: Pricing" />
    <meta name="twitter:description" content="Explore WashOn Laundry Pricing: Affordable rates for premium laundry, shoe carpet and curtain cleaning services. Discover our pricing options tailored to fit your needs."/>
    <meta name="twitter:image" content="https://washon-image.s3.ap-south-1.amazonaws.com/site-image/washon-white-bg.png"/>
        {/* Add other head content specific to the about page */}
        </Helmet>
      <div>
        <div
          className="content-container"
          style={{
            justifyContent: "left",
            // margin: window.innerWidth > 768 ? "3% 6% 3% 6%" : "2% 0 2% 0",
            color: "rgb(0, 0, 0.8)",
            backgroundColor: "#F9F9FB",
            padding: window.innerWidth > 768 ? 40 : 5,
            borderRadius: 10,
          }}
        >
          <div className="service-content-price">
            <div>
              <h1
                style={{
                  color: "rgb(0, 0, 0.8)",
                  margin: "5px 10px 15px 10px",
                }}
              >
                <strong style={{ fontSize: 20, color: "rgb(30, 30, 93)" }}>
                  WashOn Laundry Services Pricing
                </strong>
              </h1>
              <p
                style={{
                  color: "rgb(143, 152, 179)",
                  align: "justify",
                  background: "#ffffff",
                  padding: 35,
                  borderRadius: 10,
                  boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.25)",
                  margin: "5px 10px 10px 10px",
                  fontSize: window.innerWidth > 768 ? 18 : 14,
                }}
              >
                At WashOn, our pricing is transparent and straightforward. 
                Enjoy the ease of free pickup and delivery, with no hidden fees. 
                Trust us for clear pricing and reliable service, ensuring peace of mind with every order.
              </p>
            </div>
            <div
              style={{
                color: "rgb(0, 0, 0.8)",
                align: "justify",
                background: "#ffffff",
                padding: 35,
                borderRadius: 10,
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.25)",
                margin: "5px 10px 10px 10px",

                // marginTop: "4%",
              }}
            >
              <div className="service-selected-price">
                <div style={{ padding: 5 }}>
                  <h4
                    style={{
                      color: "rgb(30, 30, 93)",
                      align: "justify",
                      margin: "5px 0px 10px 5px",
                    }}
                  >
                    <strong style={{ fontSize: 20 }}>Bag Offer</strong>
                  </h4>
                  <TableContainer component={Paper} style={{ marginTop: "2%" }}>
                    <Table
                      className={classes.table}
                      aria-label="customized table"
                    >
                      <TableHead>
                        <StyledTableCell>Bags </StyledTableCell>
                        <StyledTableCell align="center">Price</StyledTableCell>
                      </TableHead>
                      <TableBody>
                        {bags[1 - 1].map((row) => (
                          <StyledTableRow key={row.name}>
                            <StyledTableCell2 component="th" scope="row">
                              {row.name}
                            </StyledTableCell2>
                            <StyledTableCell2 align="center">
                              {row.calories}
                            </StyledTableCell2>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
              <div
                style={{
                  color: "rgb(143, 152, 179)",
                  margin: "2% 0% 0% 0%",
                  fontSize: window.innerWidth > 768 ? 18 : 14,
                }}
              >
                <div>Notes:</div>
                <div
                  style={{ color: "rgb(143, 152, 179)", margin: "0% 0% 0% 1%" }}
                >
                  <ol>
                    <li>
                      Wash & Fold : Washing and tuble dry, 40 degree celsius (
                      no ironing )
                    </li>
                    <li>
                      Please note there is maximum of 24 pieces allowed. Items
                      exceeding this limit will be charge by per piece.
                    </li>
                    <li>
                      Steam Press & Wash & Press : Offer is valid only for Top
                      and Bottoms. 
                    </li>
                    <li>
                      Steam Press & Wash & Press : Items requiring special care like kandura, Abaya, Dresses etc. will be charge by per piece. 
                    </li>
                    <li>
                      This bag size is 72*50 cm, could hold upto laundry equal
                      to 2 full laundry loads at home.
                    </li>
                    <li>VAT of 5% is not included.</li>
                  </ol>
                </div>
              </div>
            </div>

            <div className="service-selected-price">
              <div style={{ width: "100%" }}>
                <h4
                  style={{
                    color: "rgb(30, 30, 93)",
                    align: "center",
                    margin: "2% 0% 2% 2%",
                  }}
                >
                  <strong style={{ fontSize: 20 }}>Price per piece</strong>
                </h4>

                {pricingData.map((item, i) => (
                  <Accordion
                    // id="panel1a-header"
                    style={{
                      align: "justify",
                      background: "#ffffff",
                      padding: 10,
                      borderRadius: 5,
                      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.25)",
                      margin: "5px 10px 10px 10px",
                      // height: !currentIndex.includes(item.category) && 100,
                      position: "unset",
                      alignItems: "center",
                      width: "100%",
                    }}
                    onClick={() => {
                      if (currentIndex.includes(item.category)) {
                        const newState = [...currentIndex];
                        newState.splice(currentIndex.indexOf(item.category), 1);
                        setCurrentIndex(newState);
                      } else {
                        setCurrentIndex([item.category, ...currentIndex]);
                      }
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore fontSize="large" />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography
                        style={{
                          fontSize: 14,
                          color: "rgb(30, 30, 93)",
                          fontWeight: "bold",
                        }}
                      >
                        {item.category}
                      </Typography>
                    </AccordionSummary>
                    {renderTable(item)}
                  </Accordion>
                ))}
              </div>
            </div>
            <div>
    <div className="download-app">
            <div className="download-text">
              <h3>Download WashOn APP!</h3>
              <p>
                Download our app to book and manage your appointments with a few
                taps, view your profile and see real time status of your
                bookings.{" "}
              </p>
              <div style={window.innerWidth < 768 ? { display: "flex" } : {}}>
                <a href="http://onelink.to/p3c5wk">
                  <img  alt="WashOn Laundry: Play Store" 
                    style={{ marginRight: "10px" }}
                    src={downloadGoogleImg}
                  />
                </a>
                <a href="http://onelink.to/p3c5wk">
                  <img alt="WashOn Laundry: App Store" src={downloadAppleImg} />
                </a>
              </div>
            </div>
            {window.innerWidth < 768 && <img alt="WashOn Laundry: Download App" src={downloadApp} />}
            {window.innerWidth > 768 && (
              <img
                alt="WashOn Laundry: WashOn App"
                style={{ position: "absolute", top: "-3%", right: "26%" }}
                src={phone1}
              />
            )}
            {window.innerWidth > 768 && (
              <img
                style={{ position: "absolute", top: "3%", right: "13%" }}
                alt="WashOn Laundry: App"
                src={phone2}
              />
            )}
    </div>
    <Link to="/booking">
      <div className="content-container" style={{ padding: 0 }}>
          <div className="services-container" style={{ padding: 0 }}>
            <div className="book-btn2" onClick={props.setBookOrder}>
            BOOK NOW
            </div>
          </div>
      </div>
    </Link>
      </div>
          </div>
        </div>
      </div>
    </div>
  );
}
